import cellRenderer from './cellRenderer'

export default { cellRenderer }
